export const URLS = {
	MORTALITY_CONTROL: 'analises/controle-mortalidade/'
};
